import React, { createContext, PropsWithChildren } from "react";
import Script from "next/script";

interface Iframely {
  load(containerElement?: HTMLElement, url?: string): void;
  load(linkElement?: HTMLAnchorElement): void;
  load(): void;
}

declare global {
  interface Window {
    iframely?: Iframely;
  }
}

export const IframelyContext = createContext<Iframely>({
  load(element?: HTMLElement, url?: string) {
    window.iframely?.load(element, url);
  },
});

export const IframelyProvider: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <>
    <Script
      src={`//cdn.iframe.ly/embed.js?key=${process.env.iframelyApiKey}`}
      async
    />
    {children}
  </>
);
